module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9781684351855_Foreword#sec1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9781684351855_Prologue#sec2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PRODUCER PROLOGUE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The 13 "), _c('i', [_vm._v("Ps")]), _vm._v(" of Producing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_1#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ONE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PASSION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_2#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TWO")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PRAYER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_3#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER THREE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PREP")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_4#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FOUR")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PROCESS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_5#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FIVE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PARTNERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_6#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SIX")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PITCH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_7#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SEVEN")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PACKAGING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_8#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER EIGHT")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PROPERTY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_9#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER NINE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_10#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TEN")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The POST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_11#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ELEVEN")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PUBLICITY "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("&")]), _vm._v(" PROMOTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_12#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TWELVE")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PROFITS (?)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Chapter_13#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER THIRTEEN")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("The PRIORITIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9781684351855_Acknowledgments_and_Credits#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKNOWLEDGMENTS AND CREDITS")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e98d60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781684351855_Contents.vue
// module id = 78
// module chunks = 0